document.addEventListener("DOMContentLoaded", function() {
  console.log("DOMContentLoaded event fired");
  // バリエーションIDとその制限数を設定
  const limitPerVariant = {
    "47701677637837": 1,
    "47701677670605": 1,
    "47701677637837": 1,
    "47702178300109": 1,
    "47702178332877": 1,
    "47701677670605": 1,
    "47702178365645": 1,
    "47702178431181": 1,
  };

  // カートページの数量入力フィールドを制限する関数
  function limitCartQuantity() {
    const cartRows = document.querySelectorAll(".cart-item");

    cartRows.forEach(row => {
      // バリエーションIDをリンクのURLから取得
      const link = row.querySelector(".cart-item__link");
      const url = new URL(link.href);
      const variantId = url.searchParams.get("variant");

      const quantityInput = row.querySelector(".quantity__input");

      if (quantityInput) {
        quantityInput.addEventListener("change", function(event) {
          if (limitPerVariant[variantId] && quantityInput.value > limitPerVariant[variantId]) {
            alert(`このアイテムは ${limitPerVariant[variantId]} 個まで購入することができます`);
            quantityInput.value = limitPerVariant[variantId];
          }
        });
      }
    });
  }

  limitCartQuantity(); // カートページの数量入力フィールドの制限を適用
});